/*
 * BlackBork - Wishlist (favorites)
 * Uygulama kurulmadan, tema icinde localStorage tabanli favori listesi.
 * Musteri hesabi gerekmez. Bu ortamda requestAnimationFrame /
 * IntersectionObserver geri cagrilari tetiklenmedigi icin hicbiri kullanilmaz.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'bb_wishlist';
  var MAX_ITEMS = 200;

  /* ---------------- Depolama ---------------- */

  function read() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(function (h) {
        return typeof h === 'string' && h.length > 0;
      });
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
    } catch (e) {
      /* kota dolu / gizli mod - sessizce gec */
    }
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = read();
    var index = list.indexOf(handle);
    var added = index === -1;
    if (added) {
      list.unshift(handle);
    } else {
      list.splice(index, 1);
    }
    write(list);
    return added;
  }

  function remove(handle) {
    var list = read();
    var index = list.indexOf(handle);
    if (index === -1) return false;
    list.splice(index, 1);
    write(list);
    return true;
  }

  /* ---------------- Para birimi ---------------- */

  function formatMoney(cents) {
    var format =
      (window.theme && window.theme.settings && window.theme.settings.money_format) || '${{amount}}';
    var value = Number(cents) || 0;

    function withDelimiters(precision, thousands, decimal) {
      var fixed = (value / 100.0).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return precision > 0 && parts[1] ? whole + decimal + parts[1] : whole;
    }

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, name) {
      switch (name) {
        case 'amount':
          return withDelimiters(2, ',', '.');
        case 'amount_no_decimals':
          return withDelimiters(0, ',', '.');
        case 'amount_with_comma_separator':
          return withDelimiters(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withDelimiters(0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return withDelimiters(2, "'", '.');
        default:
          return withDelimiters(2, ',', '.');
      }
    });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* ---------------- Kart kalpleri ---------------- */

  function syncToggles(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = read();
    var buttons = scope.querySelectorAll('.wishlist-toggle[data-wishlist-handle]');
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var active = list.indexOf(button.getAttribute('data-wishlist-handle')) !== -1;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = active
        ? button.getAttribute('data-label-remove')
        : button.getAttribute('data-label-add');
      if (label) button.setAttribute('aria-label', label);
    }
  }

  /* ---------------- Header rozeti ---------------- */

  function syncBadge() {
    var count = read().length;
    var badges = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count > 99 ? '+' : count > 0 ? String(count) : '';
      badges[i].classList.toggle('hidden', count === 0);
    }
  }

  /* ---------------- Favoriler sayfasi ---------------- */

  var renderToken = 0;

  function productUrl(handle) {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'products/' + encodeURIComponent(handle) + '.js';
  }

  function renderPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;

    var empty = document.querySelector('[data-wishlist-empty]');
    var status = document.querySelector('[data-wishlist-status]');
    var handles = read();

    /* Token her cagrida artar: ucusta olan eski bir render sonucu
       donerse gecersiz sayilir ve DOM'u geri doldurmaz. */
    var token = ++renderToken;

    function showEmpty() {
      grid.innerHTML = '';
      grid.hidden = true;
      if (status) status.hidden = true;
      if (empty) empty.hidden = false;
    }

    if (!handles.length) {
      showEmpty();
      return;
    }

    if (empty) empty.hidden = true;
    if (status) status.hidden = false;

    Promise.all(
      handles.map(function (handle) {
        return fetch(productUrl(handle))
          .then(function (response) {
            return response.ok ? response.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      if (token !== renderToken) return;

      var missing = [];
      var valid = [];
      for (var i = 0; i < products.length; i++) {
        if (products[i] && products[i].handle) {
          valid.push(products[i]);
        } else {
          missing.push(handles[i]);
        }
      }

      /* Silinmis / yayindan kaldirilmis urunleri listeden dusur */
      if (missing.length) {
        var cleaned = read().filter(function (handle) {
          return missing.indexOf(handle) === -1;
        });
        write(cleaned);
        syncBadge();
      }

      if (!valid.length) {
        showEmpty();
        return;
      }

      if (status) status.hidden = true;
      grid.hidden = false;
      grid.innerHTML = valid.map(cardHtml).join('');
      syncToggles(grid);
    });
  }

  function grabString(key, fallback) {
    var host = document.querySelector('[data-wishlist-strings]');
    var value = host && host.getAttribute('data-string-' + key);
    return value || fallback || '';
  }

  function cardHtml(product) {
    var handle = escapeHtml(product.handle);
    var url = '/products/' + handle;
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var compareAt = Number(product.compare_at_price) || 0;
    var price = Number(product.price) || 0;
    var onSale = compareAt > price;
    var soldOutLabel = grabString('soldout', '');
    var removeLabel = grabString('remove', 'Remove from favorites');

    var media =
      '<a class="wishlist-card__media" href="' +
      url +
      '" tabindex="-1" aria-hidden="true">' +
      (image
        ? '<img src="' + escapeHtml(image) + '" alt="" loading="lazy" width="600" height="600">'
        : '') +
      '</a>';

    return (
      '<li class="wishlist-card" data-wishlist-item="' +
      handle +
      '">' +
      media +
      (product.available === false && soldOutLabel
        ? '<span class="wishlist-card__sold-out">' + escapeHtml(soldOutLabel) + '</span>'
        : '') +
      '<button type="button" class="wishlist-card__remove" data-wishlist-remove="' +
      handle +
      '" aria-label="' +
      escapeHtml(removeLabel) +
      '">' +
      '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
      '</svg>' +
      '</button>' +
      '<a class="wishlist-card__title" href="' +
      url +
      '">' +
      escapeHtml(product.title) +
      '</a>' +
      '<div class="wishlist-card__price">' +
      (onSale ? '<s>' + formatMoney(compareAt) + '</s>' : '') +
      '<strong>' +
      formatMoney(price) +
      '</strong>' +
      '</div>' +
      '</li>'
    );
  }

  /* ---------------- Olaylar ---------------- */

  function announce(handle) {
    try {
      document.dispatchEvent(
        new CustomEvent('wishlist:change', { detail: { handle: handle, items: read() } })
      );
    } catch (e) {
      /* CustomEvent yoksa sessizce gec */
    }
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var toggleButton = event.target.closest('.wishlist-toggle');
    if (toggleButton) {
      event.preventDefault();
      event.stopPropagation();
      var handle = toggleButton.getAttribute('data-wishlist-handle');
      if (!handle) return;
      toggle(handle);
      syncToggles();
      syncBadge();
      renderPage();
      announce(handle);
      return;
    }

    var removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();
      var removeHandle = removeButton.getAttribute('data-wishlist-remove');
      if (!removeHandle) return;
      remove(removeHandle);
      syncToggles();
      syncBadge();
      renderPage();
      announce(removeHandle);
    }
  });

  /* Baska sekmede degisirse burayi da guncelle */
  window.addEventListener('storage', function (event) {
    if (event.key && event.key !== STORAGE_KEY) return;
    syncToggles();
    syncBadge();
    renderPage();
  });

  /* ---------------- Baslatma ---------------- */

  function boot() {
    syncToggles();
    syncBadge();
    renderPage();
  }

  /* Sonsuz kaydirma / filtre ile sonradan gelen kartlarin durumunu esitle.
     MutationObserver kare tabanli degil, bu ortamda calisir; yine de
     zaman tabanli yedek denemeler birakildi. */
  function observe() {
    if (!window.MutationObserver || !document.body) return;
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        syncToggles();
      }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
      observe();
    });
  } else {
    boot();
    observe();
  }

  window.addEventListener('load', boot);
  setTimeout(syncToggles, 600);
  setTimeout(syncToggles, 1800);

  /* Dogrulama / disaridan kullanim icin acik API */
  window.BBWishlist = {
    key: STORAGE_KEY,
    get: read,
    has: has,
    add: function (handle) {
      if (!has(handle)) toggle(handle);
      boot();
      return read();
    },
    remove: function (handle) {
      remove(handle);
      boot();
      return read();
    },
    toggle: function (handle) {
      var added = toggle(handle);
      boot();
      return added;
    },
    clear: function () {
      write([]);
      boot();
      return [];
    },
    refresh: boot,
    count: function () {
      return read().length;
    },
  };
})();
